import { Formik } from 'formik';

import { Button } from 'shared/components/ui';
import { useEventSearchContext } from 'features/events/hooks';
import { CardLayout } from 'shared/components/layouts';
import { DEFAULT_SEARCH_CONTEXT_ZIP_FILTER, SearchContextZipFilter } from 'shared/features/search';

import { EventsFilterForm } from '../EventsFilterForm';
import { Container } from './EventFilterSidebar.styles';

export function EventFilterSidebar() {
  const { zipFilter, setZipFilter } = useEventSearchContext();

  const handleSubmit = (filters: SearchContextZipFilter) => {
    setZipFilter(filters);
  };

  return (
    <CardLayout>
      <Formik
        initialValues={zipFilter ?? DEFAULT_SEARCH_CONTEXT_ZIP_FILTER}
        onSubmit={handleSubmit}
      >
        {form => (
          <Container>
            <EventsFilterForm />

            <Button
              fullWidth
              type="submit"
              color="primary"
              variant="contained"
              disableElevation
              onClick={form.submitForm}
            >
              APPLY
            </Button>
          </Container>
        )}
      </Formik>
    </CardLayout>
  );
}
